import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Manage' key='manage' value={`/ecommerce/orders/${resource.id}/manage`} />
  ]
}

export default buildMenuItems
